module.exports = __webpack_public_path__ + "static/media/banner_mobile.f6aedf9a.png";